import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import TipoListaNcmService from "./tipoListaNcmService"
import FormList from 'base/FormList'

export default function TipoListaNcmList() {

    const [service] = useState(() => new TipoListaNcmService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_tilin',
        dsName: 'descricao_tilin',
        mainField: { name: 'descricao_tilin', label: 'Descrição' },
        advFields: [
            { name: 'codigo_tilin', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_tilin', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_tilin" sortable header="Código"></Column>
            <Column field="descricao_tilin" sortable header="Descrição"></Column>
        </FormList >
    )
}
